<template>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 'login',
    data() {
      return {
        state: {}
      }
    },
    metaInfo() {
      return {
        meta: [
          { name: 'robots',
            content: 'noindex'
          }
        ]
      }
    },
    computed: {
      ...mapGetters('auth/id', ['authenticated'])
    },
    created() {
      if (!this.$auth.id.getState()) {
        this.state = {
          from: '/',
          download: false
        }
        this.$auth.id.signIn(this.state)
      } else {
        this.state = JSON.parse(this.$auth.id.getState())
      }

      if (this.state.download) {
        this.$router.push({path: this.$auth.id.getFrom(), query: {download: this.state.download}})
      } else {
        this.$router.push({path: this.$auth.id.getFrom()})
      }
    }
  }
</script>

